module.exports = __webpack_public_path__ + "static/media/other.64f21a10.svg";